import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', path: '/' },
    { label: '分类浏览', path: '/category' },
    { label: '关于我们', path: '/about' },
  ],
  categories: [
    { label: '热血漫画', path: '/category' },
    { label: '恋爱漫画', path: '/category' },
    { label: '悬疑漫画', path: '/category' },
    { label: '奇幻漫画', path: '/category' },
    { label: '搞笑漫画', path: '/category' },
  ],
  support: [
    { label: '关于我们', path: '/about' },
    { label: '联系方式', path: '/about' },
    { label: '版权声明', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-line text-2xl text-primary-400"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">龙禁漫</span>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed mb-4">
              专注于正版漫画内容的综合平台，提供海量漫画资源在线阅读与下载。热血、恋爱、悬疑、奇幻等多种题材任你选择。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200" aria-label="哔哩哔哩">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-foreground-400 text-sm hover:text-primary-400 transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.label}>
                  <Link to={link.path} className="text-foreground-400 text-sm hover:text-primary-400 transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">帮助支持</h4>
            <ul className="space-y-2.5">
              {footerLinks.support.map((link) => (
                <li key={link.label}>
                  <Link to={link.path} className="text-foreground-400 text-sm hover:text-primary-400 transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; 2026 龙禁漫 LongJinMan. 保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 text-xs hover:text-primary-400 transition-colors duration-200">隐私政策</a>
            <a href="#" className="text-foreground-500 text-xs hover:text-primary-400 transition-colors duration-200">用户协议</a>
            <a href="#" className="text-foreground-500 text-xs hover:text-primary-400 transition-colors duration-200">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}